export const registerAddons = async (): Promise<void> => {
    const gtm = await import('./g-t-m');
    gtm.configureGTM();
    const appInsights = await import('./app-insights');
    appInsights.configureAppInsights();
};
setTimeout(registerAddons, 2000);
